import { useState } from "react";
import { Button } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { joinBoardAsNewMember } from "../../models/board";

export type BoardInviteModalProps = {
  boardUid: string;
  boardTitle: string;
  userUid: string;
  onDecline: () => void;
  onJoined: () => void;
};

export function BoardInviteModal({ boardUid, boardTitle, onDecline, onJoined }: BoardInviteModalProps) {
  const { t } = useTranslation();
  const [joining, setJoining] = useState(false);

  const handleJoin = async () => {
    setJoining(true);
    try {
      await joinBoardAsNewMember(boardUid);
      onJoined();
    } catch {
      setJoining(false);
    }
  };

  return (
    <div className="box">
      <p className="title is-4">{t("modal.invite.title")}</p>
      <p className="subtitle">{t("modal.invite.description", { boardTitle, interpolation: { escapeValue: false } })}</p>
      <div className="buttons">
        <Button color="success" onClick={handleJoin} loading={joining} disabled={joining}>{t("modal.invite.join")}</Button>
        <Button onClick={onDecline} disabled={joining}>{t("modal.invite.decline")}</Button>
      </div>
    </div>
  );
}
